// extracted by mini-css-extract-plugin
export default {"wrapper":"NormalInput_wrapper__yF04w","trafficContent":"NormalInput_trafficContent__O6A4e","basicInfo":"NormalInput_basicInfo__s+cKi"};